var _style, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOoWhiteOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 117.5 69",
    style: {
      enableBackground: "new 0 0 117.5 69"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#FF8300;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.3,21.6c-0.3-0.4-0.7-0.9-1-1.3L96,20c-0.6-0.7-1.3-1.4-2-2l0,0c-0.3-0.3-0.7-0.5-1.2-0.5s-1,0.2-1.3,0.6 l0,0l-3.7,5.2l0,0c-0.2,0.3-0.3,0.6-0.3,1c0,0.5,0.2,0.9,0.5,1.2l0,0c0.9,0.8,1.6,1.7,2.2,2.7c1,1.7,1.7,3.6,1.9,5.6 c0,0.3,0.1,0.7,0.1,1V35c0,7.1-5.8,12.9-12.9,12.9l0,0c-4.2,0-8.1-2-10.5-5.4L54.3,22.1c-4.2-5.9-11.1-9.4-18.3-9.5 c-12.4,0-22.4,10.1-22.4,22.5c0,0.8,0,1.5,0.1,2.2v0.1c0.1,0.8,0.2,1.5,0.3,2.2c0,0,0,0,0,0.1c1,4.7,3.4,8.9,7,12.1 c0.3,0.4,0.8,0.6,1.3,0.6c0.7,0,1.2-0.4,1.5-1l0,0l3.3-4.7c0.2-0.3,0.4-0.6,0.4-1s-0.2-0.8-0.5-1.2l0,0c-2.6-2.5-4.1-6-4-9.6 c-0.1-3.4,1.2-6.6,3.6-9c5-5.1,13.2-5.2,18.3-0.3c0.6,0.6,1.1,1.2,1.5,1.8l14.7,20.7c7.2,10.1,21.2,12.4,31.3,5.2 s12.4-21.2,5.2-31.3C97.5,21.9,97.4,21.8,97.3,21.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.6,14.4c0-0.9-0.7-1.7-1.6-1.7h-0.1l0,0c-1.7-0.2-3.4-0.2-5.1-0.1l-1,0.1c-6.3,0.7-12,4.1-15.7,9.3 L46.6,42.6c-2.2,3.4-6,5.5-10,5.6h-0.1c-0.5,0-0.9,0.3-1.2,0.7l0,0L35.2,49l-4,5.6c-0.6,0.7-0.4,1.8,0.3,2.4 c0.2,0.1,0.3,0.2,0.5,0.3h0.1c2.2,0.2,4.4,0.3,6.6,0.2c6.3-0.7,12.1-4.1,15.8-9.3l14.4-20.4c2.3-3.1,5.8-5.1,9.7-5.4h0.1 c0.6,0,1.2-0.3,1.4-0.9l4.2-6C84.5,15.1,84.6,14.8,84.6,14.4z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOoWhiteOrange);
export default __webpack_public_path__ + "static/media/oo-white-orange.c2b6445ecb9d4fd0702b95258bda34cb.svg";
export { ForwardRef as ReactComponent };